import { PhoneIphone, Email, LocationOn, Insights } from "@mui/icons-material";

import LeadSummary from "./LeadSummary";
import PaymentsSummary from "./Payments/PaymentsSummary";
import CallLogs from "./CallLogs";
import Attachments from "./Attachments/Attachments";
import LeadTimeline from "./LeadTimeline";
import NextFollowUps from "./NextFollowUps";
import ServicesBlock from "./ServicesBlock";
import Tasks from "./Tasks/Tasks";
import Bookings from "./Bookings/Bookings";
import CustomFields from "./CustomFeilds";

export const LEAD_PAGE_BLOCKS = {
  status_timeline: {
    key: "status_timeline",
    render: (p) => <LeadTimeline {...p} />,
  },

  call_history: {
    key: "call_history",
    render: (p) => <CallLogs {...p} />,
  },

  attachments: {
    key: "attachments",
    render: (p) => <Attachments {...p} />,
  },

  lead_summary: {
    key: "lead_summary",
    render: (p) => <LeadSummary {...p} />,
  },

  custom_fields: {
    key: "custom_fields",
    render: (p) => <CustomFields {...p} />,
  },

  next_follow_up: {
    key: "next_follow_up",
    render: (p) => <NextFollowUps {...p} />,
  },

  payments: {
    key: "payments",
    render: (p) => <PaymentsSummary {...p} />,
  },

  bookings: {
    key: "bookings",
    render: (p) => <Bookings {...p} type={p.meta?.type} />,
  },

  services: {
    key: "services",
    render: (p) => <ServicesBlock {...p} />,
  },

  tasks: {
    key: "tasks",
    render: (p) => <Tasks {...p} />,
  },
};

export const LEAD_FIELDS = [
  {
    key: "contact",
    label: "Phone *",
    icon: PhoneIphone,
    iconColor: "#2563EB",
    bg: "#DBEAFE",
    validate: (v) => /^\d{10}$/.test(v),
  },
  {
    key: "email",
    label: "Email",
    icon: Email,
    iconColor: "#D97706",
    bg: "#FEF3C7",
    validate: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
  },
  {
    key: "city",
    label: "City",
    icon: LocationOn,
    iconColor: "#DC2626",
    bg: "#FEE2E2",
    path: "custom_fields.city",
  },
  {
    key: "lead_source",
    label: "Lead Source",
    icon: Insights,
    iconColor: "#7C3AED",
    bg: "#F3E8FF",
    path: "custom_fields.lead_source",
  },
];
